document.addEventListener("DOMContentLoaded", (event) => {

      //search page redirect to home page
        if (window.location.href.indexOf("/search") >= 0) {
            window.location = '/';
        }


        //product page pdf set localStorage
        let pdf_input = document.querySelector('.temp_product .pdf_url');
        if (pdf_input) {
            var pdf_urls = pdf_input.value;
            localStorage.setItem("pdf_value", pdf_urls);
        }

        //Pdf url set to Download Button
        let pdf_data = localStorage.getItem('pdf_value');
        if (pdf_data) {
            const downloadLink = document.querySelector('#download_your_pdf');
            if (downloadLink) {
            downloadLink.setAttribute('href', pdf_data);
        }

        if (document.querySelector('.temp_index') || document.querySelector('.temp_collection')) {
            localStorage.removeItem('pdf_value');
        }
        }





    //product page info section height get
    function productHeight() {
        if (window.matchMedia('(min-device-width:768px)').matches) {
            var product_selector = document.querySelector('.desc__content');
            if (product_selector){
                var div_height = product_selector.offsetHeight + 200;
                document.querySelector('.bg_main').style.height = div_height + 'px';
            }
        }
        }
        window.addEventListener('resize', function() {
            productHeight();
        });
        productHeight();


        //USA Map Js
    var Us_data_element = document.querySelector('#courses_content .map_item[data-value="usa-map"]');
    if (Us_data_element) {
        var Us_data = document.querySelector('#courses_content .map_item[data-value="usa-map"]').innerHTML;
        document.querySelector('.map_container_main').innerHTML = Us_data;

        function HoverImageChangeUSA() {
            function showHover(state, event) {
                var hoverImage = document.getElementById('hover-image-usa');
                hoverImage.src = `https://cdn.shopify.com/s/files/1/0667/8606/6630/files/${state}.png`;
                hoverImage.style.display = "block";
            }
            function hideHover() {
                var hoverImage = document.getElementById('hover-image-usa');
                hoverImage.style.display = "none";
            }
            document.querySelectorAll('.usa-map area').forEach(function (area) {
                area.addEventListener('mouseover', function (event) {
                    var state = event.target.getAttribute('alt');
                    showHover(state, event);
                });
                area.addEventListener('mouseout', hideHover);
            });
        }

        // Run function for USA map
        HoverImageChangeUSA();
    }


    // Canada Map JS
    function HoverImageChangeCanada() {
        document.querySelectorAll("#map-container-canada area").forEach(function (area) {
            area.addEventListener("mouseover", function () {
                var stateId = "#hover_" + this.getAttribute("alt");
                var state = document.querySelector(stateId);

                if (state) {
                    state.style.display = "block";
                } else {
                    console.warn("No matching element found for: " + stateId);
                }
            });

            area.addEventListener("mouseleave", function () {
                var stateId = "#hover_" + this.getAttribute("alt");
                var state = document.querySelector(stateId);

                if (state) {
                    state.style.display = "none";
                }
            });
        });
    }
    HoverImageChangeCanada();

    const map_btns = document.querySelectorAll('.map_tab_btn .button');
    const map_containers = document.querySelectorAll('#courses_content .map_item');

    if (map_btns) {
        map_btns.forEach(function (btn) {
            btn.addEventListener('click', function () {
                var value = this.getAttribute('data-name');
                map_containers.forEach(function (item) {
                    var Datavalue = item.getAttribute('data-value');
                    if (value == Datavalue) {
                        var html = item.innerHTML;
                        document.querySelector('.map_container_main').innerHTML = html;
                    }
                });
                HoverImageChangeUSA();
                HoverImageChangeCanada();
                map_btns.forEach(b => b.classList.remove("active"));
                this.classList.add("active");
            });
        });
    }


    // -------Field Advisor tab section js----------
    const tab_button = document.querySelectorAll(".tab_button_list button.button");
    const advisor_contents = document.querySelectorAll(".advisor-bio");

    tab_button.forEach(tab => {
        tab.addEventListener("click", function () {
            // Remove active class from all tabs
            tab_button.forEach(t => t.classList.remove("active"));
            this.classList.add("active");

            // Hide all content
            advisor_contents.forEach(c => c.classList.remove("active"));

            // Show selected content
            const target = document.getElementById(this.dataset.tab);
            if (target) {
                target.classList.add("active");
            }
        });
    });


    //Product page youtube video fancybox
    let video_item = document.querySelector('.temp_product .video_items');
    if (video_item) {
        Fancybox.bind('[data-fancybox="gallery"]', {});
    }
     let block_img = document.querySelector('.block-img a');
    if (block_img) {
        Fancybox.bind('[data-fancybox="preview"]', {});
    }


//product page discount popup
var popup_dis_open = document.querySelector('.popup_dis_open');
var popup_dis_close = document.querySelector('.discount__content .popup_close_icon');

if (popup_dis_open) {
    popup_dis_open.addEventListener('click', function() {
        document.querySelector('.discount_pop_content').style.display = "block";
    });
}
if (popup_dis_close) {
    popup_dis_close.addEventListener('click', function() {
        document.querySelector('.discount_pop_content').style.display = "none";
    });
}

//product page pdf program popup
var popup_pdf_open = document.querySelector('.download_pdf,.sticky_download_pdf ');
var popup_pdf_close = document.querySelector('.program_content .program_close_icon');

if (popup_pdf_open) {
    popup_pdf_open.addEventListener('click', function() {
        document.querySelector('.pdf_program_popup').style.display = "block";
    });
}
if (popup_pdf_close) {
    popup_pdf_close.addEventListener('click', function() {
        document.querySelector('.pdf_program_popup').style.display = "none";
    });
}

var sticky_pdf_open = document.querySelector('.sticky_download_pdf ');

if (sticky_pdf_open) {
    sticky_pdf_open.addEventListener('click', function() {
        document.querySelector('.pdf_program_popup').style.display = "block";
    });
}


//collection page live traning popup
   var popup_live_open = document.querySelectorAll('.live_traning_btn');
   var popup_live_close = document.querySelector('.live_traning_popup_content .live_traning_close_icon');
    if (popup_live_open.length > 0) {
    popup_live_open.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            document.querySelector('.live_traning_popup').style.display = "block";
        });
    });
    }
   if (popup_live_close) {
       popup_live_close.addEventListener('click', function() {
           document.querySelector('.live_traning_popup').style.display = "none";
       });
   }

   //product page sticky
   window.addEventListener('scroll', function () {
    var firstSection = document.querySelector('.product_section');
    var sticky = document.querySelector('.product_sticky_bar');
    var scroll = window.scrollY;
    if (!firstSection || !sticky) return;
    if (scroll>= firstSection.offsetHeight/2) {
      sticky.classList.add('show');
    } else {
      sticky.classList.remove('show');
    }
  });

// sticky bar button click
let bar_btn = document.querySelector('.sticky_add_cart');
if (bar_btn) {
    bar_btn.addEventListener('click', function(){
    let submit_btn = document.querySelector('.product__info-container .product-form .product-form__submit');
    if (submit_btn) {
        submit_btn.click();
    }
});
}


        //product page accordian
        const titles = document.querySelectorAll('.acc_title');
            if(titles){
            titles.forEach(title => {
            title.addEventListener('click', function () {
                const clickedPanel = this.nextElementSibling;

                document.querySelectorAll('.accordian_panel').forEach(panel => {
                panel.classList.remove('open');
                if (panel !== clickedPanel) {
                    panel.style.display = 'none';
                }
                });
                clickedPanel.classList.toggle('open');
                if (clickedPanel.style.display === 'block') {
                clickedPanel.style.display = 'none';
                } else {
                clickedPanel.style.display = 'block';
                }
            });
            });
        }

        //telent lms

         const talent_input = document.querySelector('#talent_input');
         const get_button = document.querySelector('.get_talent_info');
        
         if (talent_input && get_button) {
             get_button.addEventListener('click', function() {
                 const useremail = talent_input.value.trim();
                 if (useremail !== '') {
                     document.querySelector('.loader_main').style.display = 'block';
                     const formData = new FormData();
                     formData.append("userEmail", useremail);
                     fetch("http://127.0.0.1/user-api.php", {
                             method: "POST",
                             body: formData
                         })
                         .then(response => {
                             if (!response.ok) {
                                 document.querySelector('.error_msg').style.display = "block";
                                 document.querySelector('.loader_main').style.display = 'none';
                                 document.querySelector('.user_data_main').style.display = "none";
                                 document.querySelector('.user_info .name').innerHTML = '';
                                 document.querySelector('.profile_image').setAttribute('src', '');
        
                                 throw new Error("Network response was not ok");
                             }
                             return response.json();
                         })
                         .then(data => {
                             console.log("JSON Response from PHP:", data);
        
                             if (data.first_name) {
                                 document.querySelector('.loader_main').style.display = 'none';
                                 document.querySelector('.error_msg').style.display = "none";
                                 document.querySelector('.user_data_main').style.display = "block";
                                 var Name = `${data.first_name} ${data.last_name}`;
                                 var ImageSRC = data.avatar;
                                 const certifications = data.certifications;
                                 document.querySelector('.user_info .name').innerHTML = Name;
                                 document.querySelector('.profile_image').setAttribute('src', ImageSRC);
        
                                 const container = document.querySelector('.certificate_data');
                                 if (certifications.length == 0) {
                                     container.innerHTML = '<p class="certificate_error">Certificate not available</p>';
                                     document.querySelector('.loader_main').style.display = 'none';
                                 } else {
                                    var certificate_error = document.querySelector('.certificate_error');
                                    if (certificate_error){
                                       certificate_error.innerHTML = '';
                                    }
                                     document.querySelector('.get_talent_info').setAttribute('disabled', true);
                                     certifications.forEach(cert => {
                                         const html = `
                                <div class="certificate_item">
                                <p> Course Name : <strong> ${cert.course_name} </strong> </p>
                                <a href="${cert.download_url}" target="_blank" class="button button--primary view_certificate_btn">
                                Download Certificate
                                </a>
                                </div>
                                `;
                                         container.insertAdjacentHTML('beforeend', html);
                                     });
                                 }
                             } else if (data.error) {
                                 alert(data.error);
                             } else {
                                 alert("No user found");
                             }
                         })
                         .catch(error => {
                             console.error("Fetch error:", error);
                         });
                 } else {
                     alert('Please fill in the field');
                 }
             });
         }


  // input empty div hide
    var talentInput = document.querySelector('.talent_input');
    if (talentInput){
    talentInput.addEventListener('change', function (event) {
    const inputVal = event.target.value.trim();
    const length = inputVal.length;
    if (inputVal == '' || length < 5){
       document.querySelector('.get_talent_info').removeAttribute('disabled');
       document.querySelector('.user_data_main').style.display = "none";
       document.querySelector('.user_info .name').innerHTML = '';
       document.querySelector('.certificate_data').innerHTML = '';
       document.querySelector('.profile_image').setAttribute('src','');
       document.querySelector('.error_msg').style.display = "none";
    }
    });
    }

    //product grid a tag Same Height
        const links = document.querySelectorAll('.product-grid .card__content .card__heading a');
        if (links){
            let maxHeight = 0;
            links.forEach(link => {
            const height = link.offsetHeight;
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });
            links.forEach(link => {
                link.style.height = maxHeight + 'px';
            });
        }

        // home page product filter

        let filter = document.querySelector('.filter_content');
        if (filter) {
        filter.querySelector('#collection_item').addEventListener('change', async function () {
            const collectionHandle = this.value;
            // const productTypeSelect = filter.querySelector('#training_type');
            const searchBtn = filter.querySelector('.search_products');
            searchBtn.removeAttribute('disabled');

            let permitType = filter.querySelector('#permit_type');
            permitType.disabled = false;
            // productTypeSelect.innerHTML = '<option value="">Loading...</option>';
            // productTypeSelect.disabled = true;

            try {
            const res = await fetch(`${collectionHandle}/products.json?limit=250`);
            const data = await res.json();
            const products = data.products || [];
            // console.log(products);
            const productTypes = [...new Set(products.map(p => p.product_type).filter(Boolean))];

            // productTypeSelect.innerHTML = '<option value="" disabled selected>Choose Training Type</option>';
            // productTypes.forEach(type => {
            //     const option = document.createElement('option');
            //     option.value = type;
            //     option.textContent = type;
            //     productTypeSelect.appendChild(option);
            // });

            } catch (e) {
            productTypeSelect.innerHTML = '<option value="">Error loading types</option>';
            }
        });


        const searchButton = filter.querySelector('.search_products');
        searchButton.addEventListener('click', () => {
        const collection = filter.querySelector('#collection_item').value;
        // const trainingType = filter.querySelector('#training_type').value;
        const permitType = filter.querySelector('#permit_type').value;
        // const topic = filter.querySelector('#topic').value;
        const queryParams = new URLSearchParams();
        // if (trainingType) {
        //     queryParams.set('filter.p.product_type', trainingType);
        // }
        if (permitType) {
            queryParams.set('filter.p.m.custom.filter_permit_type', permitType);
        }
        // if (topic) {
        //     queryParams.set('filter.p.m.custom.topic', topic);
        // }
        const finalUrl = queryParams.toString() ? `${collection}?&${queryParams.toString()}`: collection;
            window.location.href = finalUrl;
        });
    }




});